import "./App.css";

function App() {
  // Landing page is loaded directly in index.html
  // React mounts but doesn't render anything
  return null;
}

export default App;

